import { useQuery } from '@apollo/client';
import { graphql } from 'gql.tada';

const MyTeachingClassesQuery = graphql.persisted(
  "MyTeachingClassesQuery",
  graphql(`
    query MyTeachingClassesQuery($schoolYearId: ID!, $date: ISO8601Date!, $time: String) {
      schoolYear(id: $schoolYearId) {
        id
        name
        slug
        myClassOfferings {
          id
          section
          displayName
          slug
          activeStudentCount
          scheduleBlocks {
            id
            displayTitle
            weekdays
            oneTime
            oneTimeDate
            startsAt
            endsAt
            timeLabel
            attendanceEnabled
            classroom { id name }
          }
          course {
            id
            name
            slug
          }
          term {
            id
            name
            startsOn
            endsOn
          }
        }
        myTeachingInbox(date: $date, time: $time) {
          items {
            kind
            title
            detail
            count
            urgency
            since
          }
        }
        myAttendanceRolls(date: $date) {
          date
          startsAt
          endsAt
          timeLabel
          attendanceTaken
          attendanceRecordedCount
          expectedStudentCount
          classroom { id name }
          scheduleBlock {
            id
            displayTitle
            activityKind
            attendanceEnabled
          }
        }
      }
    }
  `)
);

export { MyTeachingClassesQuery };

export function useMyTeachingClassesQuery(schoolYearId?: string, date?: string, time?: string) {
  return useQuery(MyTeachingClassesQuery, {
    variables: { schoolYearId: schoolYearId!, date: date!, time },
    skip: !schoolYearId || !date,
  });
}
